import { getIconByOrderStatus, getTextByOrderStatus } from "@domain/enums/local/getTextByOrderStatus";
import type { OrderHistoryItem } from "@domain/dtos/models/order.models";
import styles from "./orderHeader.module.scss";

interface OrderHeaderProps {
  order: OrderHistoryItem | null;
  orderId: string | undefined;
}

function getReadyTimeText(order: OrderHistoryItem): string {
  // Финальные статусы - всегда показываем текст статуса
  const finalStatuses = ["ready", "issued", "completed", "error", "canceled", "processing_finished"];
  if (finalStatuses.includes(order.status)) {
    return order.status_description || getTextByOrderStatus(order.status);
  }
  
  // Для активных статусов: если есть time_to_ready — показываем время
  if (order.time_to_ready) {
    const minutes = typeof order.time_to_ready === "string" 
      ? parseInt(order.time_to_ready, 10) 
      : order.time_to_ready;
    
    if (minutes === 0) {
      return "Готов к выдаче";
    }
    
    // Вычисляем примерное время готовности
    const now = new Date();
    const readyTime = new Date(now.getTime() + minutes * 60000);
    const hours = readyTime.getHours().toString().padStart(2, "0");
    const mins = readyTime.getMinutes().toString().padStart(2, "0");
    
    return `Будет готов примерно в ${hours}:${mins}`;
  }
  
  // Fallback на описание статуса
  return order.status_description || getTextByOrderStatus(order.status);
}

export function OrderHeader({ order, orderId }: OrderHeaderProps) {
  const orderNumber = order?.order_number ?? orderId;
  // Сокращаем номер заказа для отображения (убираем префикс ORD-)
  const displayNumber = orderNumber?.replace(/^ORD-\d+-/, "") ?? orderNumber;
  
  return (
    <div className={styles.headerInfo}>
      <h1 className={styles.headerTitle}>
        Заказ {displayNumber}
      </h1>
      <div className={styles.headerStatusName}>
        {order ? getReadyTimeText(order) : ""}
      </div>
    </div>
  );
}

interface OrderStatusIconProps {
  order: OrderHistoryItem | null;
}

export function OrderStatusIcon({ order }: OrderStatusIconProps) {
  return (
    <div
      className={`${styles.headerStatusIco}${!order ? ` ${styles.headerStatusIcoHidden}` : ""}`}
    >
      {order && getIconByOrderStatus(order.status)}
    </div>
  );
}
